import { invalidateCache } from 'api/urql/helpers/mutation';

export const updateShift = (results, args, cache, info) => {
  invalidateCache('shifts')(results, args, cache, info);
};
